module.exports = __webpack_public_path__ + "img/footer-img.45627a87.svg";